import AddressCompanyNameCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['address', 'shipments'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { showInvalid = false } = props;
    const { address, shipments = {} } = props.selectors.getJourneyStopFields(
      state,
      props.journeyId,
      props.stopId,
      fields
    );
    const { company_name: addressCompanyName } = address;

    const invalid = showInvalid && Object.values(shipments).some((status) => status === 'ASSIGNED');

    return {
      addressCompanyName,
      invalid,
    };
  })
);

export default enhance(AddressCompanyNameCell);
